import { PermitRequest } from "@components/resolvers/permit.resolvers";
import { BaseService, sipondApiToken, sipondBaseURL } from "./base.service";
import { BaseResponse, BaseResponseExternal } from "./dtos/base.dto";
import { PermitResponse, PermitSettingResponse } from "./dtos/permit.dto";
import axios from "axios";

interface PermitServiceInterface {
  queries: {
    GET_PERMIT_DATA: string;
    GET_PERMIT_SETTING: string;
  };
  request(payload: PermitRequest): Promise<BaseResponse<boolean>>;
  data(payload: { nis: string; limit: string }): Promise<PermitResponse>;
  setting(): Promise<PermitSettingResponse>;
  permitCancel(payload: { id: string }): Promise<BaseResponse>;
}
export const PermitService: PermitServiceInterface = {
  queries: {
    GET_PERMIT_DATA: "GET_PERMIT_DATA",
    GET_PERMIT_SETTING: "GET_PERMIT_SETTING",
  },
  request: async (payload: PermitRequest) => {
    try {
      // const request = await BaseService.request().post<BaseResponse<boolean>>(
      //   "/permit/request",
      //   payload
      // );
      const request = await axios.post<BaseResponse<boolean>>(
        `${sipondBaseURL}/api/perizinan/request`,
        payload,
        {
          headers: {
            token: sipondApiToken,
          },
        }
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  data: async (payload: { nis: string; limit: string }) => {
    try {
      const request = await axios.get<PermitResponse>(
        `${sipondBaseURL}/api/orangtua/permit-record`,
        {
          params: payload,
          headers: {
            token: sipondApiToken,
          },
        }
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  setting: async () => {
    try {
      const request = await axios.get<PermitSettingResponse>(
        `${sipondBaseURL}/api/perizinan/setting`,
        {
          // params: payload,
          headers: {
            token: sipondApiToken,
          },
        }
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  permitCancel: async (payload: { id: string }) => {
    try {
      const request = await axios.get<BaseResponseExternal>(
        `${sipondBaseURL}/api/perizinan/cancel`,
        {
          params: payload,
          headers: {
            token: sipondApiToken,
          },
        }
      );
      return {
        success: request.data.status,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      throw new Error(error.message);
    }
  },
};
